import { Injectable, Optional } from '@angular/core';
import { SubscriptionData } from '../interfaces/app-data.interfaces';

import 'rxjs/add/operator/map';
import { Location } from '@angular/common';
import { DefaultServiceGetCards } from './workaround/default-service-get-cards.service';
import {DefaultServiceGetSubscriptionPools} from './workaround/default-service-get-subscription-pools.service';
import {Observable} from "rxjs";
import {POOLINFO} from "../../../gen/swagger-api";


@Injectable()
export class SubscriptionService {
  location: Location;

  defaultService: DefaultServiceGetCards;
  defaultServiceSubscriptionPools: DefaultServiceGetSubscriptionPools

  constructor(location: Location, defaultService: DefaultServiceGetCards, defaultServiceSubscriptionPools: DefaultServiceGetSubscriptionPools) {
    this.location = location;
    this.defaultService = defaultService;
    this.defaultServiceSubscriptionPools = defaultServiceSubscriptionPools;
  }

  /**
   * returns a list of all cards
   */
  subscriptions(offset, limit, criteria?, searchString?, searchProperty?, filterParams?) {

    let sortString;

    if (criteria) {
      sortString = criteria.sortColumn;
      if (criteria.sortDirection === 'asc') {
        sortString = '+' + sortString;
      } else {
        sortString = '-' + sortString;
      }
    }

    // support three searchProperties:
    let iccid;
    let msisdn;
    let imei;

    switch (searchProperty) {
      case 'iccid':
        iccid = searchString;
        break;
      case 'msisdn':
        msisdn = searchString;
        break;
      case 'imei':
        imei = searchString;
        break;
      default:
        break;
    }

    // gna
    if (searchString) {
      // if (filterParams) {
      //   console.log(filterParams.selectedCardGroupIds);
      // }

      return this.defaultService.cardsGet(
        offset,
        limit,
        searchString,
        filterParams && filterParams.selectedCardGroupIds !== undefined && filterParams.selectedCardGroupIds.length !== 0 ? filterParams.selectedCardGroupIds : undefined,
        filterParams && filterParams.selectedPoolIds !== undefined && filterParams.selectedPoolIds.length !== 0 ? filterParams.selectedPoolIds : undefined,
        undefined,
        undefined,
        filterParams && filterParams.selectedStatus !== undefined && filterParams.selectedStatus.length !== 0 ? filterParams.selectedStatus : undefined,
        sortString
      )

    } else {
      return this.defaultService.cardsGet(
        offset,
        limit,
        undefined,
        filterParams && filterParams.selectedCardGroupIds !== undefined && filterParams.selectedCardGroupIds.length !== 0 ? filterParams.selectedCardGroupIds : undefined,
        filterParams && filterParams.selectedPoolIds !== undefined && filterParams.selectedPoolIds.length !== 0 ? filterParams.selectedPoolIds : undefined,
        undefined,
        undefined,
        filterParams && filterParams.selectedStatus !== undefined && filterParams.selectedStatus.length !== 0 ? filterParams.selectedStatus : undefined,
        sortString
      )
    }

  }

  poolSubscriptions(offset, limit, criteria?, searchString?, searchProperty?, filterParams?) {

    let sortString;

    if (criteria) {
      sortString = criteria.sortColumn;
      if (criteria.sortDirection === 'asc') {
        sortString = '+' + sortString;
      } else {
        sortString = '-' + sortString;
      }
    }

    // support three searchProperties:
    let name;
    let country;
    let mnoId;

    switch (searchProperty) {
      case 'poolName':
        name = [searchString];
        break;
      case 'country':
        country = [searchString];
        break;
      case 'mno':
        mnoId = [searchString];
        break;
      default:
        break;
    }

    if (searchString) {
      return this.defaultServiceSubscriptionPools.poolsGet(
        offset,
        limit,
        undefined,
        name,
        country,
        mnoId,
        sortString);
    } else {
      return this.defaultServiceSubscriptionPools.poolsGet(
        offset,
        limit,
        undefined,
        undefined,
        undefined,
        undefined,
        sortString);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/subscription.service.ts